import { render, staticRenderFns } from "./multiInsertPage.vue?vue&type=template&id=2d13c793&"
import script from "./multiInsertPage.vue.ts?vue&type=script&lang=ts&"
export * from "./multiInsertPage.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports